import {
  SELFBOOK_REQUEST,
  SELFBOOK_SUCCESS,
  SELFBOOK_FAILURE,
  SELFBOOK_GET,
  SELFBOOK_GET_LIST,
  SELFBOOK_CREATE,
  SELFBOOK_DELETE,
  SELFBOOK_POPULAR_GET_LIST,
  SELFBOOK_POPULAR_REQUEST,
  SELFBOOK_POPULAR_SUCCESS,
  SELFBOOK_POPULAR_FAILURE,
  SELFBOOK_CATEGORIES_GET,
  SELFBOOK_UPDATE
} from '@/store/types'

import axios from '@/store/axios'

/* TODO: @stan, 
  Refactor keyMapper values as global constant and 
  methods for converting from and to
*/

/*
Not mapped keys
 - buyTp
*/
const keyMapper = {
  bookCd: 'id',
  bookDesc: 'description',
  bookNm: 'title',
  bookPrice: 'price',
  bookStatus: 'status',
  catgryCd: 'id',
  catgryNm: 'title',
  thumbTp: 'color'
}

const state = {
  selfbooks: null,
  totalCount: 0,
  current: null,
  isLoading: false,
  error: null,
  popular: null,
  isPopularLoading: false,
  meta: {}
}

const getters = {
  getSelfBooks: (state) => state.selfbooks,
  getPopularSelfBooks: (state) => state.popular,
  isSelfBookLoading: (state) => state.isLoading,
  isPopularSelfBookLoading: (state) => state.isPopularLoading,
  getCurrentSelfBook: (state) => state.current,
  getSelfBookTotalCount: (state) =>
    state.meta.totalCount || (state.selfbooks ? state.selfbooks.length : 0)
}

const actions = {
  [SELFBOOK_POPULAR_GET_LIST]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(SELFBOOK_POPULAR_REQUEST)

      axios
        .get(`/selfbook/book/list`)
        .then((resp) => {
          commit(SELFBOOK_POPULAR_SUCCESS, {
            popular: resp.data.result.selfbookList
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(SELFBOOK_POPULAR_FAILURE, err)
          reject(err)
        })
    })
  },
  [SELFBOOK_GET_LIST]: ({ commit }, { category = 'ALL', page = 1 }) => {
    return new Promise((resolve, reject) => {
      commit(SELFBOOK_REQUEST)

      /* 
        Due to legal restrictions currently (as of 2020-08-04), API route is same for 
        popular get list and my published selfbook get list
      */
      axios
        .get(`/selfbook/book/list?pageNo=${page}&searchTp=${category}`)
        .then((resp) => {
          commit(SELFBOOK_SUCCESS, {
            selfbooks: resp.data.result.selfbookList,
            meta: {
              lastLoaded: resp.data.respTime
              //totalCount: resp.data.page.totalCount
            }
          })
          resolve(resp)
        })
        .catch((err) => {
          commit(SELFBOOK_FAILURE, err)
          reject(err)
        })
    })
  },
  [SELFBOOK_CREATE]: ({ commit }, selfbook) => {
    return new Promise((resolve, reject) => {
      commit(SELFBOOK_REQUEST)

      axios
        .post(`/selfbook/register`, { selfbook })
        .then((resp) => {
          const newSelfbook = { ...selfbook, ...resp.data.result }

          commit(SELFBOOK_SUCCESS, { selfbook: newSelfbook })
          resolve(resp)
        })
        .catch((err) => {
          commit(SELFBOOK_FAILURE, err)
          reject(err)
        })
    })
  },
  /*
    TODO: @stan Refactor this
  */
  [SELFBOOK_CATEGORIES_GET]: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      commit(SELFBOOK_REQUEST)

      id = id || 'A'

      axios
        .get(`/selfbook/category/list/${id}`)
        .then((resp) => {
          commit(SELFBOOK_SUCCESS, {})
          const list = resp.data.result.catgryList
          list.map((item) => {
            Object.keys(item).map((key) => {
              if (keyMapper[key]) {
                item[keyMapper[key]] = item[key]
              }
            })
          })
          resolve(list)
        })
        .catch((err) => {
          commit(SELFBOOK_FAILURE, err)
          reject(err)
        })
    })
  },
  [SELFBOOK_GET]: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      commit(SELFBOOK_REQUEST)

      axios
        .get(`/selfbook/book/info/${id}/`)
        .then((resp) => {
          commit(SELFBOOK_SUCCESS, { selfbook: resp.data.result.bookInfo })
          resolve(resp)
        })
        .catch((err) => {
          commit(SELFBOOK_FAILURE, err)
          reject(err)
        })
    })
  },
  [SELFBOOK_UPDATE]: ({ commit }, { id, selfbook, updateType }) => {
    return new Promise((resolve, reject) => {
      commit(SELFBOOK_REQUEST)

      axios
        .put(`/selfbook/book/${id}?updateTp=${updateType}`, { selfbook })
        .then((resp) => {
          commit(SELFBOOK_SUCCESS, { selfbook: resp.data.result.bookInfo })
          resolve(resp)
        })
        .catch((err) => {
          commit(SELFBOOK_FAILURE, err)
          reject(err)
        })
    })
  },
  [SELFBOOK_DELETE]: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      commit(SELFBOOK_REQUEST)

      axios
        .delete(`/selfbook/book/${id}`)
        .then((resp) => {
          commit(SELFBOOK_SUCCESS, { deleted: id })
          resolve(resp)
        })
        .catch((err) => {
          commit(SELFBOOK_FAILURE, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [SELFBOOK_REQUEST]: (state) => {
    state.isLoading = true
  },
  [SELFBOOK_SUCCESS]: (state, { selfbooks, selfbook, meta, deleted }) => {
    state.isLoading = false
    if (selfbooks) {
      selfbooks.map((sb) => {
        Object.keys(sb).map((key) => {
          if (keyMapper[key]) {
            sb[keyMapper[key]] = sb[key]
          }
        })
      })
      state.selfbooks = selfbooks
    }

    if (meta) {
      state.meta = { ...state.meta, ...meta }
    }

    if (selfbook) {
      Object.keys(selfbook).map((key) => {
        if (keyMapper[key]) {
          selfbook[keyMapper[key]] = selfbook[key]
        }
      })
      state.current = selfbook

      if (
        state.selfbooks &&
        state.selfbooks.find((sb) => sb.id === selfbook.id)
      ) {
        state.selfbooks = [
          ...state.selfbooks.filter((sb) => sb.id !== selfbook.id),
          selfbook
        ]
      }
    }

    if (deleted) {
      state.selfbooks = state.selfbooks.filter((sb) => sb.id !== deleted)
    }
  },
  [SELFBOOK_FAILURE]: (state, err) => {
    state.isLoading = false
    state.error = err
  },
  [SELFBOOK_POPULAR_REQUEST]: (state) => {
    state.isPopularLoading = true
  },
  [SELFBOOK_POPULAR_SUCCESS]: (state, { popular }) => {
    state.isPopularLoading = false

    if (popular) {
      popular.map((sb) => {
        Object.keys(sb).map((key) => {
          if (keyMapper[key]) {
            sb[keyMapper[key]] = sb[key]
          }
        })
      })
      state.popular = popular
    }
  },
  [SELFBOOK_POPULAR_FAILURE]: (state, err) => {
    state.isPopularLoading = false
    state.error = err
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
